<template>
  <div class="container-prop-component checkbox-prop-component">
    <v-checkbox
      :disabled="readonly"
      class="checkbox-prop-component"
      :label="$t(name)"
      color="success"
      v-model="localValue"
      :hint="$t(schema.hint)"
      persistent-hint
      dense
      @change="$emit('change', localValue)"
    ></v-checkbox>
  </div>
</template>
<script>
export default {
  name: 'dr-property-check-box',
  props: ['schema', 'value', 'readonly'],
  data() {
    return {
      name: '',
      enumValue: [],
      label: '',
      lastId: ''
    }
  },
  mounted() {
    this.name = this.schema.name
    this.enumValue = this.schema.enum || null
  },
  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  updated() {
    this.label =
      this.enumValue === null
        ? ''
        : this.enumValue.find(x => {
          if (x.value == Boolean(this.value)) {
            return x.text
          }
        }).text
  }
}
</script>
<style scoped>
.checkbox-prop-component {
  margin: 0;
  text-align: left;
  color: rgba(0, 0, 0, 0.6);
}
</style>
